import { Label, Switch } from "@xola/ui-kit";
import React from "react";
import { Experience, PaymentMethod, Source } from "types";
import { Currency } from "../../Common/Currency";
import { RadioInput } from "../../Common/RadioInput";

interface PaymentRequirementSelectorProps {
    experience: Experience;
    canChangePaymentMethods: boolean;
    onPaymentMethodChange: (value: PaymentMethod) => void;
    onCreditCardRequiredChange: (value: boolean, source: string) => void;
}

export const PaymentRequirementSelector = ({
    experience,
    canChangePaymentMethods,
    onPaymentMethodChange,
    onCreditCardRequiredChange,
}: PaymentRequirementSelectorProps) => {
    return (
        <div className="space-y-2 text-gray-darker">
            {canChangePaymentMethods && (
                <div>
                    <RadioInput
                        checked={experience.paymentMethod === PaymentMethod.CREDIT_CARD}
                        name="paymentMethod"
                        onChange={() => onPaymentMethodChange(PaymentMethod.CREDIT_CARD)}
                    >
                        Credit Card payment required on checkout
                    </RadioInput>
                    <RadioInput
                        checked={experience.paymentMethod === PaymentMethod.LATER}
                        name="paymentMethod"
                        onChange={() => onPaymentMethodChange(PaymentMethod.LATER)}
                    >
                        No payment required on checkout
                    </RadioInput>
                </div>
            )}
            <Label>
                Collect credit card details for <Currency>{0}</Currency> purchases
            </Label>

            <Switch.Group>
                <div className="flex flex-col space-y-2">
                    <div>
                        <span>
                            <Switch
                                isChecked={experience.requireCCForSources?.includes(Source.CHECKOUT)}
                                onChange={(enabled: boolean) => onCreditCardRequiredChange(enabled, Source.CHECKOUT)}
                            />
                            <Switch.Label direction="right">Checkout</Switch.Label>
                        </span>
                    </div>
                    <div>
                        <span>
                            <Switch
                                isChecked={experience.requireCCForSources?.includes(Source.OFFICE)}
                                onChange={(enabled: boolean) => onCreditCardRequiredChange(enabled, Source.OFFICE)}
                            />
                            <Switch.Label direction="right">Back Office</Switch.Label>
                        </span>
                    </div>
                </div>
            </Switch.Group>
        </div>
    );
};
